import automaticOptimizationModule from "./automaticOptimizationModule"

automaticOptimizationModule.controller("automaticOptimizationControllerEdition",
    [
        "$scope",
        "$q",
        "$state",
        "$translate",
        "autocompleteFactory",
        "automaticOptimizationService",
        "automaticOptimizationConfig",
        "remoteExceptionHandler",
        "loadingService",
        "messagesModal", (
            $scope,
            $q,
            $state,
            $translate,
            autocompleteFactory,
            automaticOptimizationService,
            automaticOptimizationConfig,
            remoteExceptionHandler,
            loadingService,
            messagesModal) => {

        const EVERY_DAY = "background.task.schedule.everyDay"
        const WEEKDAYS = "background.task.schedule.weekdays"
        const WEEKENDS = "background.task.schedule.weekends"

        const MONDAY = "background.task.schedule.monday"
        const TUESDAY = "background.task.schedule.tuesday"
        const WEDNESDAY = "background.task.schedule.wednesday"
        const THURSDAY = "background.task.schedule.thursday"
        const FRIDAY = "background.task.schedule.friday"
        const SATURDAY = "background.task.schedule.saturday"
        const SUNDAY = "background.task.schedule.sunday"

        const WEEKDAY_NAMES = [MONDAY, TUESDAY, WEDNESDAY, THURSDAY, FRIDAY]
        const WEEKEND_NAMES = [SATURDAY, SUNDAY]

        $scope.findWeekdays = function () {
            return [
                {name: MONDAY, value: "MON"},
                {name: TUESDAY, value: "TUE"},
                {name: WEDNESDAY, value: "WED"},
                {name: THURSDAY, value: "THU"},
                {name: FRIDAY, value: "FRI"},
                {name: SATURDAY, value: "SAT"},
                {name: SUNDAY, value: "SUN"},
                {name: EVERY_DAY, value: "*"},
                {name: WEEKDAYS, value: "MON,TUE,WED,THU,FRI"},
                {name: WEEKENDS, value: "SUN,SAT"}
            ]
        }

        $scope.automaticOptimizationConfig = {}
        $scope.automaticOptimizationConfig.startTime = 0
        $scope.automaticOptimizationConfig.genericParamConfigurations = []
        $scope.vehicles = autocompleteFactory.lazyLoader("vehicle")

        $scope.init = () => {
            if (automaticOptimizationConfig) {
                $scope.automaticOptimizationConfig.taskId = automaticOptimizationConfig.taskId
                $scope.automaticOptimizationConfig.taskName = automaticOptimizationConfig.taskName
                $scope.automaticOptimizationConfig.user = {
                    "id": automaticOptimizationConfig.user.id,
                    "sourceId": automaticOptimizationConfig.user.email
                }
                $scope.automaticOptimizationConfig.startTime = convertToMillis(automaticOptimizationConfig.periodConfiguration)
                $scope.automaticOptimizationConfig.weekdays = convertToWeekdaysArray(automaticOptimizationConfig.periodConfiguration)
                $scope.automaticOptimizationConfig.genericParamConfigurations = automaticOptimizationConfig.genericParamConfigurations
            }

            loadingService(automaticOptimizationService.getAutomaticOptimizationClassifications())
                .then(function (response) {
                    $scope.classificationsTags = response
                })
        }
        $scope.init()

        $scope.genericParamConfigurationsQuantity = $scope.automaticOptimizationConfig.genericParamConfigurations.length
        $scope.tableOptions = {
            allRecords: $scope.automaticOptimizationConfig.genericParamConfigurations,
            records: [],
            pagination: {
                maxPageSizes: [10, 25, 50, 100],
                maxPageSize: 10,
                onPaginate: function (firstResult, maxResults) {
                    return $q.when($scope.tableOptions.allRecords.slice(firstResult, firstResult + maxResults))
                        .then(function (data) {
                            return {
                                firstResult: firstResult,
                                maxResults: maxResults,
                                count: $scope.genericParamConfigurationsQuantity,
                                result: data
                            }
                        })
                }
            },
            onRegisterPagination: function (api) {
                api.seekPage(1)
            }
        }

        $scope.createNewAutomaticOptimizationConfig = () => {
            return {
                minValue: null,
                maxValue: null,
                minWeight: null,
                maxWeight: null,
                minVolume: null,
                maxVolume: null,
                vehicle: null,
                classification: null
            }
        }

        $scope.getMinValue = (value, decimals) => {
            return value + (1 / (10 ** decimals))
        }

        $scope.getClassificationsTags = () => {
            return $scope.classificationsTags
        }
        $scope.formatTag = (value) => {
            if (!value){
                return value
            }
            return $translate.instant( "automaticOptimization.classification." + value.sourceId )
        }


        function convertToMillis(cronPeriodConfiguration) {
            const [second, minute, hour] = cronPeriodConfiguration.split(" ")
            const startTime = new Date()
            startTime.setUTCHours(parseInt(hour), parseInt(minute), parseInt(second), 0)
            return startTime.getTime()
        }

        function convertToWeekdaysArray(cronPeriodConfiguration) {
            const weekdaysToCompare = cronPeriodConfiguration.split(" ")[5].split(",")
            return $scope.findWeekdays().filter(weekdays => {
                return weekdaysToCompare.includes(weekdays.value)
            })
        }

        $scope.findUsers = function (sourceId) {
            return automaticOptimizationService.findUsers(sourceId)
                .catch(remoteExceptionHandler())
                .then((response) => {
                    return response.result
                })
        }

        $scope.save = function () {
            $scope.automaticOptimizationConfig.genericParamConfigurations = $scope.tableOptions.records
            convertToCRON()
            loadingService(automaticOptimizationService.save($scope.automaticOptimizationConfig))
                .catch(remoteExceptionHandler())
                .then(() => messagesModal("dialog.success", "entity.validator.successMessage")
                    .then(() => $state.go("r2.automaticOptimizationSearch"))
                )
        }

        $scope.back = function () {
            $state.go("r2.automaticOptimizationSearch")
        }

        function convertToCRON() {
            const weekdays = $scope.automaticOptimizationConfig.weekdays.map(weekday => weekday.value).join(",")
            const date = new Date($scope.automaticOptimizationConfig.startTime)
            const hours = String(date.getUTCHours()).padStart(2, "0")
            const minutes = String(date.getUTCMinutes()).padStart(2, "0")
            const seconds = String(date.getUTCSeconds()).padStart(2, "0")
            $scope.automaticOptimizationConfig.periodConfiguration = `${seconds} ${minutes} ${hours} * * ${weekdays}`
        }

        $scope.updateWeekdays = function () {
            let weekdays = $scope.automaticOptimizationConfig.weekdays
            if (weekdays.length) {
                let lastElement = weekdays[weekdays.length - 1]
                $scope.automaticOptimizationConfig.weekdays = clearsArrayElements(weekdays, lastElement.name)
            }
        }

        function clearsArrayElements(weekdaysArray, lastElementName) {
            return weekdaysArray.filter(item => {
                const currentName = item.name
                if (lastElementName === EVERY_DAY) {
                    return currentName === EVERY_DAY
                }
                if (currentName === EVERY_DAY) {
                    return false
                }
                if (lastElementName === WEEKDAYS) {
                    return !WEEKDAY_NAMES.includes(currentName)
                }
                if (WEEKDAY_NAMES.includes(lastElementName)) {
                    return currentName !== WEEKDAYS
                }
                if (lastElementName === WEEKENDS) {
                    return !WEEKEND_NAMES.includes(currentName)
                }
                if (WEEKEND_NAMES.includes(lastElementName)) {
                    return currentName !== WEEKENDS
                }
                return true
            })
        }
    }])